import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';
// import { BrowserTracing } from '@sentry/tracing';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
// Sentry.init({
//     dsn: 'https://6561aa2b47514229a2e14b6bbe85e74f@o141702.ingest.sentry.io/4504916821934080',
//     integrations: [
//         new BrowserTracing({
//             tracePropagationTargets: ['https://uat.bookings.ai.media/', 'https://bookings.ai.media/', 'http://localhost:8081/', 'http://127.0.0.1:8081/'],
//             routingInstrumentation: Sentry.routingInstrumentation,
//         }),
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0,
// });

if (environment.production) {
    Sentry.init({
        dsn: 'https://6561aa2b47514229a2e14b6bbe85e74f@o141702.ingest.sentry.io/4504916821934080',
        integrations: [
          // Registers and configures the Tracing integration,
          // which automatically instruments your application to monitor its
          // performance, including custom Angular routing instrumentation
          Sentry.browserTracingIntegration(),
          // Registers the Replay integration,
          // which automatically captures Session Replays
          Sentry.replayIntegration(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['https://uat.bookings.ai.media/', 'https://bookings.ai.media/'],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
